import { observer } from 'mobx-react-lite';

import { MESSAGE_CONTENT_TYPE_ATTRIBUTE, MessageContentType } from '@gem/utils';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { QuotedSelectionHighlight } from 'APP/main/ChatView/Messages/Message/components/QuoteSelectionHighlight/QuotedSelectionHighlight';

import { MessageLayout } from '../../MessageLayout/MessageLayout';
import { ForwardMessage } from '../components/ForwardMessage/ForwardMessage';
import { QuotedMessage } from '../components/QuotedMessage/QuotedMessage';
import { SenderName } from '../components/SenderName/SenderName';
import StatusBar from '../components/StatusBar';
import { ThreadButton } from '../components/ThreadButton/ThreadButton';
import Translate from '../components/Translate';
import styles from './FileBubble.styles.m.scss';

export const FileBubble = observer((props) => {
  const { message, children, messageViewPageType, isView } = props;
  const { comment } = message.renderPayload;

  return (
    <MessageLayout
      message={message}
      className={styles.bubble}
      messageViewPageType={messageViewPageType}
      isView={isView}
    >
      <div className={styles.container}>
        <SenderName
          message={message}
          className={styles.senderName}
        />
        <QuotedMessage
          message={message}
          className={styles.quote}
        />
        {message.forward && !message.isSavedMessagesLeft && (
          <ForwardMessage
            message={message}
            className={styles.forward}
          />
        )}
        {children}
        {!comment && (
          <StatusBar
            className={styles.statusBar}
            message={message}
          />
        )}
        {comment && comment.length && (
          <div className={styles.comment}>
            <div
              className={styles.commentText}
              {...{ [MESSAGE_CONTENT_TYPE_ATTRIBUTE]: MessageContentType.Text }}
            >
              <QuotedSelectionHighlight
                highlightedText={message.highlightedText}
                originalText={comment}
                groupId={message.groupId}
              >
                <TextRenderer
                  className={styles.text}
                  userMentions={message.payload.userMentions}
                  keyWords={message.payload.keyWords}
                >
                  {comment}
                </TextRenderer>
              </QuotedSelectionHighlight>
            </div>
            <StatusBar
              message={message}
              className={styles.commentedStatusBar}
            />
          </div>
        )}
      </div>
      <ThreadButton
        message={message}
        className={styles.threadButton}
      />
      <Translate message={message} />
    </MessageLayout>
  );
});
